module.exports = __webpack_public_path__ + "img/12-2.305d5a43.png";